import MxSelectSectorsField, {
  MxSelectSectorsFieldProp
} from "@rf-l1/form/selects/MxSelectSectorField";
import { useMxFieldControllerContext } from "@rf/context/MxFieldController";
type omit = "value" | "id" | "name" | "testId" | "items" | "onChange";

export type MxFormSelectSectorFieldProp = Omit<MxSelectSectorsFieldProp, omit>

const MxFormSelectSectorField = (props: MxFormSelectSectorFieldProp) => {
  const { onChange, onBlur, name, value, invalid, id, testId } =
    useMxFieldControllerContext();

  return (
    <MxSelectSectorsField
      {...props}
      id={id}
      testId={testId}
      onChange={onChange}
      onBlur={onBlur}
      name={name}
      value={value}
      error={invalid}
    />
  );
};

export default MxFormSelectSectorField;
